export default "__VITE_ASSET__BluYBzKI__"